
<app-form-control
  [customLabel]="customLabel"
  [helpText]="helpText"
  [inline]="inline"
  [label]="label"
>
  <div [ngClass]="{ 'input-group-sm': small_input, 'input-group': true }">
    <input
      [(ngModel)]="contactSearchTerm"
      type="text"
      [appAutocomplete]="'/contacts/autocomplete_contact_by_name'"
      [data]="params"
      [include_item]="include_item"
      (autocompleteSelect)="contactSearchOnSelect($event)"
      [placeholder]="placeholder || 'Search for contact'"
      class="form-control"
      [disabled]="!select_only && (!!contactId || !editable)"
      name="contact-search"
      ngDefaultControl
    />
    <div class="input-group-append" *ngIf="!select_only">
      <button type="button" class="btn btn-primary" [disabled]="!contactId || !editable" (click)="clearSelectedContact()">
        <span class="fas fa-pencil-alt"></span>
      </button>
    </div>
  </div>
</app-form-control>